import PersonalInfoStep from './PersonalInfoStep';

export default PersonalInfoStep;
